import { transport } from '@opengov/app-core/transport';

import { RootFolderResponse } from './types';

export const ensureRootFolder = async (
  entityId: number,
  displayPublicationTab?: boolean
): Promise<RootFolderResponse> =>
  transport
    .url(`/api/stories/v1/rootFolder/${entityId}`)
    .json({
      displayPublicationTab
    })
    .post()
    .json()
    .then((response: RootFolderResponse) => response);
